'use strict';

function _instanceof(left, right) {
  if (
    right != null &&
    typeof Symbol !== 'undefined' &&
    right[Symbol.hasInstance]
  ) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

// function isValidDomain(origin, customDomain = '') {
//   // Domain and api domain
//   const params = new URLSearchParams(window.location.search);
//   const env = params.get('env') || '';
// let allowedOrigins = [
//     'https://www.gevme.com',
//     'https://showcase-dev.gevme.com',
//     'https://showcase-dev.gev.me',
//     'https://showcase.gev.me',
//     'https://live.gev.me',
//     'https://live-dev.gevme.com',
//     'https://live.gevme.com',
//     'https://admin.gevme.com',
//     'https://admin.gev.me',
//     'https://admin-dev.gevme.com',
//   ];

//   if (
//     (process.env.NODE_ENV === 'development' ||
//       process.env.NODE_ENV === 'LOCAL') &&
//     env === 'localhost'
//   ) {
//     allowedOrigins.push('http://localhost:3001');
//   }

//   if (customDomain) {
//     allowedOrigins.push(customDomain);
//   }

//   return allowedOrigins.some((domain) => origin === domain);
// }

function handleMessageLivebar(event, iframeId) {
  const checkIfPercentageForm = (value) =>
    /^(\d+|(\.\d+))(\.\d+)?%$/.test(value);
  //message
  try {
    var livebarWebComponent = document.querySelector('gevme-live-bar');
    var livebar = livebarWebComponent.querySelector('iframe#GevmeLiveBar');
    var payload = event.data;
    var gevmetemplatechat = document.querySelector('.gevme-template-chat');
    gevmetemplatechat.style.transition = 'all 300ms ease-out 0s';
    livebar.style.transition = 'none';

    if (!payload) return;

    try {
      if (payload && typeof payload === 'string') {
        payload = JSON.parse(payload);
      }
    } catch (error) {
      console.error('Not a valid object');
      return false;
    }
    if (payload && payload.eventType === 'listenerAttached') {
      console.log('listenerAttached: ', { payload });
      document.getElementById(iframeId).contentWindow.postMessage(
        JSON.stringify({
          action: 'gevme-json',
          from: 'livebar',
          data: JSON.stringify(window.GEVME),
        }),
        '*'
      );
    }

    if (payload.eventType === 'expand' && payload.expand) {
      if (!payload.mobile) {
        if (typeof payload.closable === 'boolean' && !payload.closable) {
          livebar.style.width =
            !payload.isFloat && checkIfPercentageForm(payload.customDrawerWidth)
              ? '100%'
              : payload.customDrawerWidth;
        } else {
          livebar.style.width =
            !payload.isFloat && checkIfPercentageForm(payload.customDrawerWidth)
              ? '100%'
              : payload.customDrawerWidth;
          livebar.style.position = 'fixed';
          livebar.style.right =
            payload && payload.position === 'left' ? 'unset' : 0;
          livebar.style.left =
            payload && payload.position === 'left' ? 0 : 'unset';

          if (!payload.isFloat) {
            livebar.style.transition = 'all 300ms ease-out 0s';
            livebar.style.position = 'relative';
            gevmetemplatechat.style.flex = `0 0 ${payload.customDrawerWidth}`;
          }
        }

        livebar.style.height =
          livebar.parentElement.getBoundingClientRect().height + 'px';
      }

      if (payload.mobile) {
        livebar.style.width = '100%';
        livebar.style.position = 'fixed';
        livebar.style.right = '0';
        livebar.style.left = '0';
        livebar.style.top = '0';
        livebar.style.bottom = '0';
      }

      livebarWebComponent.classList.add('live-bar-open');
      livebar.classList.add('live-bar-open');
      livebarWebComponent.classList.remove('live-bar-close');
      livebar.classList.remove('live-bar-close');
    }

    if (
      payload.eventType === 'expand' &&
      typeof payload.expand === 'boolean' &&
      !payload.expand
    ) {
      if (!payload.mobile) {
        livebar.style.height =
          livebar.parentElement.getBoundingClientRect().height + 'px';
        livebar.style.position = 'relative';
        gevmetemplatechat.style.flex = '0 0 70px';

        if (
          (payload === null || payload === void 0
            ? void 0
            : payload.position) === 'right'
        ) {
          var gevmeLiveBar = document.querySelector('gevme-live-bar');
          gevmeLiveBar.style = 'display: flex; justify-content: flex-end;';
        }

        livebar.style.width = '70px';
      }

      if (payload.mobile) {
        livebar.style.width = '100%';
        livebar.style.height = '100%';
        livebar.style.position = 'relative';
      }

      livebarWebComponent.classList.remove('live-bar-open');
      livebar.classList.remove('live-bar-open');
      livebarWebComponent.classList.add('live-bar-close');
      livebar.classList.add('live-bar-close');
    }

    if (payload.eventType === 'open-profile') {
      livebar.style.width = '100%';
      livebar.contentWindow.postMessage(
        JSON.stringify({
          eventType: payload.eventType,
          eventData: payload.eventData,
        }),
        '*'
      );
    }

    if (payload.eventType === 'open-direct-message') {
      livebar.style.width = '100%';
      livebar.contentWindow.postMessage(
        JSON.stringify({
          eventType: payload.eventType,
          eventData: payload.eventData,
        }),
        '*'
      );
    }

    if (payload.eventType === 'bookmark') {
      livebar.contentWindow.postMessage(
        JSON.stringify({
          eventType: payload.eventType,
          eventData: payload.eventData,
        }),
        '*'
      );
    }

    if (payload.eventType === 'open-main-chat') {
      livebar.contentWindow.postMessage(
        JSON.stringify({
          eventType: payload.eventType,
          eventData: payload.eventData,
        }),
        '*'
      );
    }
  } catch (error) {
    console.error(error);
  }
}

function _typeof(obj) {
  '@babel/helpers - typeof';

  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ('value' in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function');
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true,
    },
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }

  return self;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === 'function' ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== 'function') {
      throw new TypeError('Super expression must either be null or a function');
    }

    if (typeof _cache !== 'undefined') {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true,
      },
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === 'undefined' || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === 'function') return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf('[native code]') !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf =
    Object.setPrototypeOf ||
    function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf
    : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
  return _getPrototypeOf(o);
}

try {
  var GevmeLiveBar = /*#__PURE__*/ (function (_HTMLElement) {
    _inherits(GevmeLiveBar, _HTMLElement);

    var _super = _createSuper(GevmeLiveBar);

    _createClass(GevmeLiveBar, null, [
      {
        key: 'observedAttributes',
        get: function get() {
          return ['settings'];
        },
      },
    ]);

    function GevmeLiveBar() {
      var _this;

      _classCallCheck(this, GevmeLiveBar);

      _this = _super.call(this);
      _this.state = {
        settings: null,
      };

      _this.setSettings(_this.getAttribute('settings'));

      return _this;
    }

    _createClass(GevmeLiveBar, [
      {
        key: 'attributeChangedCallback',
        value: function attributeChangedCallback(name, oldValue, newValue) {
          if (name === 'settings') {
            this.setSettings(newValue);
          }
        },
      },
      {
        key: 'getFilter',
        value: function getFilter() {
          return this.state.filter;
        },
      },
      {
        key: 'setSettings',
        value: function setSettings(value) {
          this.state.settings = value;
        },
      },
      {
        key: 'windowEventListener',
        value: function windowEventListener(iframeId) {
          window.addEventListener('message', (e) => {
            if (isValidDomain(e.origin, window?.GEVME?.setting?.customDomain)) {
              handleMessageLivebar(e, iframeId);
            }
          });
        },
      },
      {
        key: 'connectedCallback',
        value: function connectedCallback() {
          try {
            var frameWidth = '70px';
            var livebarWidget = (window.GEVME.widgets || []).find(function (
              widget
            ) {
              return widget.widget === 'live-bar';
            });

            if (livebarWidget && livebarWidget.enabled) {
              var _window,
                _window$GEVME,
                _window$GEVME$livepag,
                _window2,
                _window2$GEVME;

              this.style.minWidth = '70px';
              var objset = JSON.parse(this.state.settings);
              var iframe = document.createElement('iframe');
              var redirectBaseURI = `${
                window?.GEVME?.setting?.customDomain ||
                process.env.TEMPLATE_APP_DOMAIN
              }/widgets`;
              iframe.id = 'GevmeLiveBar';
              iframe.name = 'GevmeLiveBar';
              iframe.title = 'Gevme Live Bar';
              iframe.sandbox =
                'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin';
              iframe.allow =
                'camera *; microphone *; accelerometer; magnetometer; autoplay; encrypted-media; gyroscope; geolocation; picture-in-picture; xr-spatial-tracking; webvr; vr; webxr; xr';
              iframe.allowFullScreen = true;
              iframe.seamless = true;
              iframe.loading = 'lazy';
              iframe.frameBorder = '0';
              iframe.src = ''.concat(
                redirectBaseURI,
                '/livebar',
                '?slug='.concat(
                  (_window = window) === null || _window === void 0
                    ? void 0
                    : (_window$GEVME = _window.GEVME) === null ||
                      _window$GEVME === void 0
                    ? void 0
                    : (_window$GEVME$livepag = _window$GEVME.livepage) ===
                        null || _window$GEVME$livepag === void 0
                    ? void 0
                    : _window$GEVME$livepag.slug
                ),
                ''.concat(
                  (_window2 = window) !== null &&
                    _window2 !== void 0 &&
                    (_window2$GEVME = _window2.GEVME) !== null &&
                    _window2$GEVME !== void 0 &&
                    _window2$GEVME.isPreview
                    ? '&isPreview=true'
                    : ''
                )
              );
              iframe.style = 'position: relative; width: '.concat(
                frameWidth,
                '; height: 100%; background: transparent; z-index: 9999999; overflow: hidden'
              );
              iframe.onerror = function (e) {
                console.error(error);
              };
              iframe.onload = function () {
                console.log('livebar loaded');
                console.log(this.contentWindow);
                this.contentWindow.postMessage(
                  JSON.stringify({
                    action: 'gevme-json',
                    data: JSON.stringify(window.GEVME),
                  }),
                  '*'
                );
              };

              this.append(iframe);

              while (this.attributes.length > 0) {
                this.removeAttribute(this.attributes[0].name);
              }

              this.windowEventListener('GevmeLiveBar');
            } else {
              console.error('no settings define');
              return false;
            }
          } catch (error) {
            console.error(error);
          }
        },
      },
    ]);

    return GevmeLiveBar;
  })(/*#__PURE__*/ _wrapNativeSuper(HTMLElement));

  window.customElements.define('gevme-live-bar', GevmeLiveBar);
} catch (error) {
  console.error(error.message);
}
